export enum Role {
  SUPER_ADMIN = 'SUPER_ADMIN',
  INVENTORY_ADMIN = 'INVENTORY_ADMIN',
  ADMIN = 'ADMIN',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
  DEVELOPMENT_TEAM = 'DEVELOPMENT_TEAM'
}
